// The invoice list endpoint returns PagedResultInv (named type on the backend),
// not the generic Paged<T>. Re-export the invoice types for the Fees page.
export type { InvoiceView, PaymentView, FeeItemDto, InstallmentView, RefundView } from './types';

/** What the office says happened, in their words. ⚠ Mirrors Domain.Fees.WhatHappened. */
export const WHAT_HAPPENED = [
  { value: 'ChequeBounced', label: 'A cheque bounced' },
  { value: 'KeyedTwice', label: 'The same payment was entered twice' },
  { value: 'KeyedAgainstTheWrongStudent', label: 'It was entered against the wrong student' },
  { value: 'WrongAmountKeyed', label: 'The amount entered was wrong' },
  { value: 'FamilyPaidTooMuch', label: 'The family paid too much' },
  { value: 'StudentLeft', label: 'The student has left' },
  { value: 'ChargeRaisedInError', label: 'The charge itself should never have been raised' },
] as const;

/**
 * ⚠ THE POINT OF ASKING BEFORE ACTING. A clerk who voids a payment that should have been refunded
 * produces a ledger that balances perfectly and a bank account short by the refund — and nobody
 * notices until an audit, by which time there are forty of them.
 */
export interface ReversalAdviceView {
  kind: 'VoidPayment' | 'Refund' | 'CancelInvoice' | 'CarryCredit';
  do: string;
  because: string;
  warning: string | null;
  receivedPaise: number;
  alreadyRefundedPaise: number;
  refundablePaise: number;
  studentStillEnrolled: boolean;
  /** ⚠ Null unless the answer is a refund AND the dates were supplied. See RefundSchedule. */
  scheduleRefundablePaise: number | null;
  schedulePercent: number | null;
  scheduleProcessingFeePaise: number | null;
  scheduleExplanation: string | null;
}
import type { InvoiceView } from './types';

export interface PagedResultInv {
  items: InvoiceView[];
  total: number;
  skip: number;
  take: number;
}

/**
 * What the server says a split would look like.
 *
 * ⚠ `ok: false` WITH A `refusal` IS A 200, not an error, on the preview endpoint — the whole point
 * of a preview is to be told why without an exception. On the apply endpoint the same refusal
 * arrives as an error instead. A screen that handles only one of those renders a refused split as
 * an empty schedule and lets somebody press the button anyway.
 */
export interface InstalmentPlanView {
  ok: boolean;
  refusal: string | null;
  lines: InstalmentLineView[];
  totalPaise: number;
  /** ⚠ Written to be said aloud to a parent at a counter. The lines above are for checking it. */
  words: string;
}

export interface InstalmentLineView {
  number: number;
  amountPaise: number;
  /** ⚠ A DateOnly here ("2026-07-10"), while InvoiceView.installments carries a DateTimeOffset. */
  dueOn: string;
}
